/**
 * Chuỗi của màn Quản lý User OpenCore (`/rpa/opencore-users`, tab User và Role) — namespace `rpa.openCoreUsers`,
 * `rpa.openCoreRoles` của web-portal native, đổi sang kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaDanhBa = {
  rpaDanhBa: {
    moTa: 'Người dùng, role OpenCore, trạng thái online và RPA Client của tổ chức.',
    tabUser: 'User',
    tabRole: 'Role',
    nguon: 'Nguồn: OpenCore',
    xem: 'Xem chi tiết',
    sua: 'Sửa',
    khoa: 'Khoá User',
    moKhoa: 'Mở khoá User',
    xoaUser: 'Xoá User',
    xoaRole: 'Xoá role',
    taoUser: 'Tạo User',
    taoRole: 'Tạo role',
    rongLoc: 'Không có dòng nào khớp bộ lọc',
    giayTruoc: '{{so}} giây trước',
    phutTruoc: '{{so}} phút trước',
    chuaCoRole: 'Chưa có role',
    themRole: '+{{so}}',
    roleKhongDoc: 'Không đọc được role',
    kpiTong: 'Tổng User đã tải',
    kpiEnabled: 'Enabled',
    kpiOnline: 'Online',
    kpiDisabled: 'Disabled',
    kpiRpa: 'Có RPA Client',
    timUser: 'Tìm tên / username / email / ID / role...',
    locTrangThai: 'Lọc theo trạng thái',
    moiTrangThai: 'Mọi trạng thái',
    locValidated: 'Lọc theo Validated',
    moiValidated: 'Mọi Validated',
    daValidated: 'Validated',
    chuaValidated: 'Chưa validated',
    locRole: 'Lọc theo role',
    moiRole: 'Mọi role',
    loc: {
      enabled: 'Đang hoạt động (Enabled)',
      disabled: 'Disabled',
      online: 'Online gần đây',
      rpa: 'Có RPA heartbeat',
      unvalidated: 'Chưa validated',
    },
    daTaiUser: '{{so}} User · tối đa 500 User mỗi lần đọc',
    rongUser: 'OpenCore chưa có User nào',
    rongUserMoTa: 'Tạo User để cấp License và cho Robot đăng nhập OpenRPA.',
    cotUser: 'Tên / Username / Email',
    cotId: 'User ID',
    cotRole: 'Role',
    cotTrangThai: 'Trạng thái',
    cotValidated: 'Validated',
    cotEmailValidated: 'Email Validated',
    cotLastSeen: 'Last Seen',
    cotRpaHeartbeat: 'RPA Heartbeat',
    cotPhienBan: 'Phiên bản',
    openRpaVer: 'OpenRPA {{ver}}',
    clientVer: 'Client {{ver}}',
    user: {
      online: 'Online',
      offline: 'Offline',
      disabled: 'Disabled',
      co: 'Có',
      chua: 'Chưa',
    },
    baoVe: {
      service: 'Tài khoản dịch vụ FOXAI dùng để kết nối OpenCore — không khoá, không xoá được.',
      self: 'User trùng với tài khoản OpenCore bạn đang kết nối — không xoá được.',
    },
    ngan: {
      openRpa: 'OpenRPA Version',
      client: 'Client Version',
      taoLuc: 'Tạo lúc',
      suaLuc: 'Cập nhật lần cuối',
      roleTrucTiep: 'Role (trực tiếp)',
      khongCoRole: 'Không có role trực tiếp nào.',
      thanhVien: 'Thành viên ({{so}})',
      chuaCoThanhVien: 'Chưa có thành viên.',
    },
    form: {
      taoTieuDe: 'Tạo User OpenCore',
      suaTieuDe: 'Sửa User · {{ten}}',
      ten: 'Tên hiển thị',
      username: 'Username / Email',
      usernameGoiY: 'Dùng để đăng nhập OpenCore. 3–128 ký tự: chữ thường, số và . _ @ + -',
      email: 'Email',
      matKhau: 'Mật khẩu',
      matKhauGoiY: 'Tối thiểu {{min}} ký tự.',
      xacNhanMatKhau: 'Nhập lại mật khẩu',
      enabled: 'Enabled',
      validated: 'Validated',
      emailValidated: 'Email Validated',
      role: 'Role',
      chonRole: 'Chọn role...',
      roleGoiY: 'Thêm hoặc gỡ role. Role License RPA được đồng bộ từ màn Quản lý License RPA.',
      roleChuaBiet: 'Chưa đọc được role hiện tại của User nên không sửa role được. Bấm Làm mới rồi thử lại.',
      quaLicense: '(qua License)',
      loiTen: 'Nhập tên hiển thị.',
      loiUsernameThieu: 'Nhập Username / Email.',
      loiUsername: 'Username 3–128 ký tự, chỉ gồm chữ, số và . _ @ + -',
      loiEmail: 'Email chưa đúng dạng, ví dụ ten@congty.vn.',
      loiMatKhauNgan: 'Mật khẩu cần tối thiểu {{min}} ký tự.',
      loiMatKhauDai: 'Mật khẩu tối đa {{max}} ký tự.',
      loiXacNhan: 'Hai mật khẩu chưa khớp. Nhập lại cho giống ô Mật khẩu.',
      tao: 'Tạo User',
      luu: 'Lưu User',
      daTao: 'Đã tạo User {{ten}}.',
      daLuu: 'Đã lưu User {{ten}}.',
    },
    admin: {
      tieuDe: 'Thêm vào role admins?',
      than: '{{ten}} sẽ có quyền quản trị rất cao trên OpenCore của tổ chức.',
      nut: 'Thêm vào admins',
    },
    xacNhan: {
      khoaTieuDe: 'Khoá User {{ten}}?',
      khoaThan: 'User bị chặn lệnh chạy Workflow mới qua Native và License của User được đồng bộ lại. Phiên Workflow đang chạy không bị huỷ.',
      moKhoaTieuDe: 'Mở khoá User {{ten}}?',
      moKhoaThan: 'User hoạt động lại. Quyền chạy vẫn phụ thuộc License còn hiệu lực.',
      xoaTieuDe: 'Xoá User {{ten}}?',
      xoaThan: 'User bị xoá khỏi OpenCore và gỡ khỏi mọi role. Thao tác này không hoàn tác được.',
      daKhoa: 'Đã khoá User {{ten}}.',
      daMoKhoa: 'Đã mở khoá User {{ten}}.',
      daXoa: 'Đã xoá User {{ten}}.',
      xoaRoleTieuDe: 'Xoá role {{ten}}?',
      xoaRoleThan: '{{so}} thành viên sẽ mất quyền từ role này. Thao tác này không hoàn tác được.',
      daXoaRole: 'Đã xoá role {{ten}}.',
    },
    kpiRole: 'Tổng role',
    kpiRoleHeThong: 'Role hệ thống',
    kpiRoleTuyChinh: 'Role tuỳ chỉnh',
    timRole: 'Tìm tên role / mô tả / ID...',
    roleGoiY: 'Chỉ hiện role mà tài khoản dịch vụ OpenCore của tổ chức đọc được.',
    rongRole: 'Chưa đọc được role nào',
    rongRoleMoTa: 'Tạo role để gom User và cấp quyền trên OpenCore.',
    cotTenRole: 'Tên role',
    cotThanhVien: 'Số thành viên',
    cotMoTa: 'Mô tả',
    cotLoai: 'Loại',
    roleHeThongKhongXoa: 'Role hệ thống không xoá được.',
    role: {
      heThong: 'Hệ thống',
      license: 'License RPA',
      rpa: 'RPA',
      tuyChinh: 'Tuỳ chỉnh',
    },
    roleForm: {
      taoTieuDe: 'Tạo role OpenCore',
      suaTieuDe: 'Sửa role · {{ten}}',
      ten: 'Tên role',
      tenHeThong: 'Role hệ thống không đổi tên được.',
      moTa: 'Mô tả',
      thanhVien: 'Thành viên',
      chonUser: 'Chọn User...',
      thanhVienLicense: 'Thành viên role này do License RPA đồng bộ — gán qua màn Quản lý License RPA.',
      thieuQuyenUser: 'Cần quyền đọc User OpenCore để chọn thành viên.',
      adminsGoiY: 'Thành viên role admins có quyền quản trị rất cao trên OpenCore.',
      loiTen: 'Nhập tên role.',
      tao: 'Tạo role',
      luu: 'Lưu role',
      daTao: 'Đã tạo role {{ten}}.',
      daLuu: 'Đã lưu role {{ten}}.',
    },
  },
} as const;
